/**
 * Validade do cartão digitada no campo com máscara `validity` (utils/masks):
 * aceita MM/AA, como vem impresso no cartão, e MM/AAAA. Devolve o ano com 4
 * dígitos (o que o POST /payments/tokenize espera) ou null se incompleta ou
 * com mês inválido.
 */
export function lerValidade(validity: string): { month: number; year: number } | null {
  const m = /^(0[1-9]|1[0-2])\/(\d{2}|\d{4})$/.exec(validity);
  if (!m) return null;
  const year = parseInt(m[2], 10);
  return { month: parseInt(m[1], 10), year: year < 100 ? 2000 + year : year };
}

/** Cartão vale até o último dia do mês impresso. */
export function validadeVencida(v: { month: number; year: number }, hoje = new Date()): boolean {
  return v.year * 12 + v.month < hoje.getFullYear() * 12 + (hoje.getMonth() + 1);
}
